import { Button, ButtonText } from '@/components/ui/button';
import { Text } from '@/components/ui/text';
import { VStack } from '@/components/ui/vstack';

/**
 * What the signed-in app shows when it cannot load the reader's account, in
 * place of a blank screen. Nothing behind the shell can load without the
 * account, so the one action is to try again.
 */
export function CurrentUserUnreachable({ onRetry }: { onRetry: () => void }) {
  return (
    <VStack
      className="w-full flex-1 items-center justify-center gap-3 px-6 web:min-h-[60vh]"
      accessibilityLiveRegion="polite"
      testID="current-user-unreachable">
      <Text className="text-center font-heading text-lg text-typography-900">
        Can’t reach Primum
      </Text>

      <Text className="max-w-md text-center text-base text-typography-700">
        Check your connection and try again.
      </Text>

      <Button size="sm" action="primary" onPress={onRetry}>
        <ButtonText>Try again</ButtonText>
      </Button>
    </VStack>
  );
}
